// extracted by mini-css-extract-plugin
module.exports = {"loadingBase":"#257E43","icon":"styles_icon__36uyO"};